import(/* webpackMode: "eager" */ "/vercel/path0/app/web/events/[slug]/ui/MainContainer/MainContainer.tsx");
